import EmptyRouterView from './../views/directive/EmptyRouterView.vue'
import ReportTable from './../views/directive/ReportTable.vue'
import Home from './../views/directive/Home.vue'

export const routes = [
  { path: '/directivo', 
    component: EmptyRouterView,
    children: [
      {
        path:'',
        name:'directiveReport',
        component:ReportTable,
      },
      {
        path: 'inicio',
        name: 'directiveHome', 
        component: Home,
      },
    ]
  },
]